import { logError } from "utilities/Functions/GlobalHelperFunctions";
import { OSM_API, CRM_API, VALUE_CHAIN_API } from "utilities/AdiApi";
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";


const IssueAPI = {
  getAll: async () => {
    const bizCode = getBizCode()
    // const bizCode = 'papl'
    try {
      const res = await VALUE_CHAIN_API.get(`valuechain_issues/${bizCode}`)
      return res.data.body
    } catch (e) {
      logError(e)
      throw e
    }
  },
  getId: async () => {
    const bizCode = getBizCode()
    // const bizCode = 'papl'
    try {
      const res = await VALUE_CHAIN_API.get(`valuechain_issues/${bizCode}?get_id`)
      return res.data
    } catch (e) {
      logError(e)
      throw e
    }
  },

  getById: async (refId: string) => {
    const bizCode = getBizCode()
    // const bizCode = 'papl'
    try {
      const res = await VALUE_CHAIN_API.get(`valuechain_issues/${bizCode}?refID=${refId}`)
      return res.data.body[0]
    } catch (e) {
      logError(e)
      throw e
    }
  },
  addIssue: async (payload: any) => {
    const bizCode = getBizCode()
    // const bizCode = 'papl'
    try {
      const res = await VALUE_CHAIN_API.post(`valuechain_issues/${bizCode}`, payload)
      return res
    } catch (e) {
      logError(e)
      throw e
    }
  },
  updateIssue: async (payload: any) => {
    const bizCode = getBizCode()
    // const bizCode = 'papl'
    try {
      const res = await VALUE_CHAIN_API.put(`valuechain_issues/${bizCode}`, payload)
      return res
    } catch (e) {
      logError(e)
      throw e
    }
  }

}

export default IssueAPI